<div class="vct-detail" *ngIf="detail">

  <!-- Header: name + description -->
  <div class="vct-detail-header">
    <div class="vct-detail-title-row">
      <mat-icon class="vct-detail-title-icon">settings_input_hdmi</mat-icon>
      <h3 class="vct-detail-name">{{ detail.templateName }}</h3>
    </div>
    <p class="vct-detail-desc" *ngIf="detail.description">{{ detail.description }}</p>
    <p class="vct-detail-desc vct-detail-desc--empty" *ngIf="!detail.description">No description.</p>
  </div>

  <mat-divider></mat-divider>

  <!-- Settings list -->
  <ul class="vct-setting-list">

    <li class="vct-setting-row">
      <mat-icon class="vct-setting-icon">cable</mat-icon>
      <div class="vct-setting-text">
        <span class="vct-setting-label">Protocol</span>
        <span class="vct-setting-value">{{ detail.protocol === 'Rdp' ? 'RDP' : 'VNC' }}</span>
      </div>
    </li>

    <li class="vct-setting-row">
      <mat-icon class="vct-setting-icon">file_copy</mat-icon>
      <div class="vct-setting-text">
        <span class="vct-setting-label">Allow Copy from VM</span>
        <span class="vct-setting-value">
          <mat-icon class="vct-flag-icon"
                    [class.vct-flag-on]="detail.allowCopy"
                    [class.vct-flag-off]="!detail.allowCopy">
            {{ iconFor(detail.allowCopy) }}
          </mat-icon>
          {{ detail.allowCopy ? 'Allowed' : 'Blocked' }}
        </span>
      </div>
    </li>

    <li class="vct-setting-row">
      <mat-icon class="vct-setting-icon">content_paste</mat-icon>
      <div class="vct-setting-text">
        <span class="vct-setting-label">Allow Paste to VM</span>
        <span class="vct-setting-value">
          <mat-icon class="vct-flag-icon"
                    [class.vct-flag-on]="detail.allowPaste"
                    [class.vct-flag-off]="!detail.allowPaste">
            {{ iconFor(detail.allowPaste) }}
          </mat-icon>
          {{ detail.allowPaste ? 'Allowed' : 'Blocked' }}
        </span>
      </div>
    </li>

    <li class="vct-setting-row">
      <mat-icon class="vct-setting-icon">folder_shared</mat-icon>
      <div class="vct-setting-text">
        <span class="vct-setting-label">File Sharing (upload &amp; download)</span>
        <span class="vct-setting-value">
          <mat-icon class="vct-flag-icon"
                    [class.vct-flag-on]="detail.allowFileUpload"
                    [class.vct-flag-off]="!detail.allowFileUpload">
            {{ iconFor(detail.allowFileUpload) }}
          </mat-icon>
          {{ detail.allowFileUpload ? 'Enabled' : 'Disabled' }}
        </span>
        <span *ngIf="detail.allowFileUpload" class="vct-setting-hint">
          Upload: drag a file onto the VM screen or use the Upload button in the toolbar.
          Download: move files to the shared network drive inside the VM and they will save
          to your browser automatically.
          Note: clipboard file transfer is not supported — only text can be copied.
        </span>
      </div>
    </li>

    <li class="vct-setting-row">
      <mat-icon class="vct-setting-icon">ondemand_video</mat-icon>
      <div class="vct-setting-text">
        <span class="vct-setting-label">Allow Screen Recording</span>
        <span class="vct-setting-value">
          <mat-icon class="vct-flag-icon"
                    [class.vct-flag-on]="detail.allowScreenRecording"
                    [class.vct-flag-off]="!detail.allowScreenRecording">
            {{ iconFor(detail.allowScreenRecording) }}
          </mat-icon>
          {{ detail.allowScreenRecording ? 'Allowed' : 'Blocked' }}
        </span>
      </div>
    </li>

    <li class="vct-setting-row">
      <mat-icon class="vct-setting-icon">volume_up</mat-icon>
      <div class="vct-setting-text">
        <span class="vct-setting-label">Allow Audio Playback</span>
        <span class="vct-setting-value">
          <mat-icon class="vct-flag-icon"
                    [class.vct-flag-on]="detail.allowAudioPlayback"
                    [class.vct-flag-off]="!detail.allowAudioPlayback">
            {{ iconFor(detail.allowAudioPlayback) }}
          </mat-icon>
          {{ detail.allowAudioPlayback ? 'Allowed' : 'Blocked' }}
        </span>
      </div>
    </li>

    <li class="vct-setting-row">
      <mat-icon class="vct-setting-icon">wallpaper</mat-icon>
      <div class="vct-setting-text">
        <span class="vct-setting-label">Show Desktop Background</span>
        <span class="vct-setting-value">
          <mat-icon class="vct-flag-icon"
                    [class.vct-flag-on]="detail.allowBackground"
                    [class.vct-flag-off]="!detail.allowBackground">
            {{ iconFor(detail.allowBackground) }}
          </mat-icon>
          {{ detail.allowBackground ? 'Shown' : 'Hidden' }}
        </span>
      </div>
    </li>

  </ul>

  <mat-divider></mat-divider>

  <!-- Metadata footer -->
  <div class="vct-detail-meta">
    <p class="vct-meta-row">
      <mat-icon class="vct-meta-icon">schedule</mat-icon>
      Updated {{ detail.updatedAt | date:'dd MMM yyyy' }}
    </p>
  </div>

</div>
